import React from 'react';
import SEO from './SEO';
import { generateOrganizationSchema, generateWebsiteSchema } from '../utils/structuredData';

function ConcursoGuiones(props) {

  const featuredImage = 'https://discover.af-pictures.com/storage/app/media/upload-img/Poster%20Horizontal%20Summer%20Screams.png';

  // Imágenes del concurso (storage del CMS)
const IMG_BASE = 'https://discover.af-pictures.com/storage/app/media/upload-img/';
const IMG = {
  logo: IMG_BASE + 'summer-screams-logo-sin-fondo.png',
  logoAF: IMG_BASE + 'Logo%20Af%20blanco.png',
  poster: IMG_BASE + 'Poster%20Summer%20Screams%20(logo%20m%C3%A1s%20visible).png',
  titulo: IMG_BASE + 'Titulo%20de%20concurso%20verano.png',
  vestido: IMG_BASE + 'EL%20VESTIDO_IMG.png',
  silla: IMG_BASE + 'Poster%20La%20Silla.jpg',
};

  const organizationSchema = generateOrganizationSchema();
  const websiteSchema = generateWebsiteSchema();
  const combinedSchema = [organizationSchema, websiteSchema];

  return (
    <>
      <SEO
        title='Concurso de Guiones - Summer Screams'
        description='El plazo del Concurso de Guiones Summer Screams ha finalizado. Gracias a todos los participantes por vuestras historias.'
        keywords='concurso de guiones, cortometraje de terror, guionistas, AF Pictures, concurso cine, talento emergente'
        url='https://afpictures.com/concurso-guiones'
        image='https://afpictures.com/img/af-pictures-og.jpg'
        structuredData={combinedSchema}
      />

      <div style={{ backgroundImage: 'url(' + featuredImage + ')', backgroundPosition: 'center', backgroundSize: 'cover' }} className="relative background-cover items-center h-[40vh]">
        <h1 style={{ fontSize: '200%' }} className="text-center w-full pt-[20vh] font-semibold text-white">CONCURSO DE GUIONES</h1>
      </div>

      <div className={"w-full bg-zinc-900 text-white " + props.transition}>
        <div className="max-w-[820px] mx-auto px-4 md:px-8 py-12 lg:py-20">

          <div className="text-center mb-10">
            <p className="font-mono text-2xl font-bold text-center text-red-800">AF PICTURES PRESENTA</p>
            <img
              src={IMG.logo}
              alt="Summer Screams"
              className="mx-auto w-full md:w-96 max-w-full mb-4"
            />
            <h2 className="text-2xl md:text-3xl font-semibold">Concurso de Guiones</h2>
          </div>

          <section className="mb-16 border border-white/30 rounded-xl bg-black/40 p-8 md:p-12 text-center">
            <h3 className="text-2xl md:text-3xl font-bold mb-6">
              Ha finalizado el periodo de entrega de guiones
            </h3>
            <p className="text-lg md:text-xl text-gray-200 leading-relaxed">
              Millones de gracias a todos los que os habéis animado a participar; leer vuestras
              historias y descubrir tanto talento es un verdadero placer. Nuestro equipo ya está
              valorando cada una de las propuestas.
            </p>
            <p className="text-lg md:text-xl text-gray-200 leading-relaxed mt-4 font-semibold">
              ¡Gracias por formar parte de esto!
            </p>
          </section>

          <section className="mb-12">
          {/* Stills de películas AF */}
          {/* Se ensancha más allá del contenedor de 820px centrándose sobre el eje de la página. */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-10 mb-12 lg:w-[min(1120px,100vw-4rem)] lg:ml-[50%] lg:-translate-x-1/2">
            {[
              { src: IMG.vestido, title: 'EL VESTIDO', genre: 'Terror psicológico', url: '/catalogo/el-vestido' },
              { src: IMG.silla, title: 'LA SILLA', genre: 'Thriller de terror', url: '/catalogo/la-silla' },
            ].map((film) => (
              <a
                key={film.title}
                href={film.url}
                className="relative aspect-[3/4] rounded-lg overflow-hidden group border border-white/[0.12] block cursor-pointer"
              >
                <img
                  src={film.src}
                  alt={'Fotograma de ' + film.title}
                  loading="lazy"
                  className="absolute inset-0 w-full h-full object-cover brightness-[0.55] transform transition-all duration-700 group-hover:scale-105 group-hover:brightness-75"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-black/40 pointer-events-none"></div>
                <div className="absolute inset-x-0 bottom-8 md:bottom-10 flex flex-col items-center gap-3 px-4 text-center">
                  <span className="border border-red-700 text-red-600 text-[10px] md:text-xs font-semibold uppercase tracking-[0.25em] px-3 py-1">
                    {film.genre}
                  </span>
                  <p className="text-white font-bold uppercase text-3xl md:text-5xl leading-none">
                    {film.title}
                  </p>
                </div>
              </a>
            ))}
          </div>
          </section>
          <section className="mb-12">
             <div className="relative text-center mt-8 mb-8">
              <p className="italic text-gray-200">Si tienes cualquier tipo de duda o consulta, por favor escríbenos a <a href="mailto:afclub@afpictures.com" className='text-red-600'>afclub@afpictures.com</a>.</p>
            </div>

            {/* Logo del concurso al pie */}
            <div className="text-center pt-12 flex flex-row md:flex-row items-center justify-center">
              <img
                src={IMG.logoAF}
                alt="Logo de AF Pictures"
                loading="lazy"
                className="mx-auto w-40 md:w-48 opacity-90"
              />
              <img
                src={IMG.logo}
                alt="Summer Screams — Concurso de Guiones del Club AF"
                loading="lazy"
                className="mx-auto w-40 md:w-48 opacity-90"
              />
            </div>
          </section>
        </div>
      </div>
    </>
  );
}

export default ConcursoGuiones;
